module.exports = __webpack_public_path__ + "static/00040.c9356690.jpg";